module.exports = __webpack_public_path__ + "img/5-4.4deb51b0.jpg";